import React, { useState, useEffect } from 'react';
import { updateSubject } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';

const EditSubjectModal = ({ subject, onClose, onSubjectUpdated }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (subject) {
            setName(subject.name);
        }
    }, [subject]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!name) {
            setError('Name is required.');
            return;
        }

        try {
            await updateSubject(subject.id, { name });
            onSubjectUpdated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Edit Subject</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder='Name'
                        />
                    </div>
                    <div className='actions-centered'>
                        <button type="submit" className="submit-button text-button">Update</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditSubjectModal;